import styles from './DotSpan.module.scss';

const DotSpan = () => {
  return <span className={styles.floor_dot} />;
};

export default DotSpan;
